import {Select} from '@mui/material'


import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-multi-lang'
import API, {iStatusOperation } from '../../services/api/api';
import './Filters.css'
import { useCookies } from 'react-cookie';
import { useAPI } from '../../services/hoc/useAPI';


interface StatisticsFilterProps {
   
    trigger?: Function  , 
    open:boolean
}


export const StatisticStatusFilter= ( props: StatisticsFilterProps ) => {

    const t = useTranslation()
   
    const Endpoints = useAPI()
    const [active, setActive] = useState<number>(-1)
    const [status,setStatus]= useState<iStatusOperation[]>([])
    const get_statusoperations = ()=>{
        Endpoints.orders()
        .statusOperations({page:1,page_size:100})
        .then(res=>{
            if (res.data.data){
                let status_lst:iStatusOperation[] = []
                status_lst= res.data.data.status_operations.reduce((acc:iStatusOperation[],curr)=> {
                    if (!acc.some(item=> item.status === curr.status)){
                        acc.push(curr)
                    }
                    return acc
                }
           ,[] )
           setStatus(status_lst)
            
    }
})

            
       
        .catch(err=>{
            console.log(err)
        })
    }

    useEffect(()=>{
        get_statusoperations()
    },[])

    return(
        <ul className= {`statistics-filter ${props.open?'open':'close'}`}>
            { status && status.length> 0 ? status.map((item, index) => {
            
                return(
                <li key={index} onClick={() => { setActive(index);
                 if(props.trigger) props.trigger(item) }} 
                 className={active === index ? "active" : ""}>
                    <i>{t( item.status) }</i>
                </li> )
            }) : "" }
        </ul>
    )
}